export default "__VITE_ASSET__CmSP8YDu__"